import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslocoModule} from '@jsverse/transloco';
import {FooterComponent} from '../../shared/ui/footer/footer.component';

@Component({
  selector: 'cov-public-application',
  imports: [RouterOutlet, TranslocoModule, FooterComponent],
  templateUrl: './public-application.component.html',
  styleUrl: './public-application.component.scss',
})
export class PublicApplicationComponent {}
